<template>
    <BreadCrumb PageTitle="Modifier un article" />
    <EditArticle />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditArticle from "../../components/Article/EditArticle.vue";
  
    export default defineComponent({
      name: "EditArticlePage",
      components: {
        BreadCrumb,
        EditArticle,
      },
    });
  </script>